// This file was originally auto-generated by Lovable. Hardcoded fallbacks
// added on 2026-04-20 after a Lovable rebuild shipped without VITE_SUPABASE_*
// env vars set, causing `supabaseUrl is required` at module init and a
// fully broken site. Both values below are public-safe: the URL is
// preconnected in index.html, and the publishable key is the anon JWT
// (designed to be exposed client-side; protected by RLS policies).
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

// Exported so other modules don't have to re-hardcode the project ref.
// Audit fix #8 (2026-05-13) — was duplicated in 5 other files.
export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  "https://scrrcgnxagnqklsbmmwy.supabase.co";

export const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNjcnJjZ254YWducWtsc2JtbXd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxMDM1NjEsImV4cCI6MjA4ODY3OTU2MX0.si0M1PuLL9gELpHXovYgUaPtV_xrZQ1N_H-FywhhxmM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});